module.exports = __webpack_public_path__ + "static/media/outfitter_picks_showcase.0110c80a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/outfitter_picks_showcase.webp
// module id = 248
// module chunks = 0